<template>
  <v-card flat class="r5">
    <v-container grid-list-md fluid :class="classProp">
      <v-layout row wrap justify-space-between>
        <div class="flex xs12 px-3 py-2 mb-3 di-flex text-xs-left align-center font-weight-bold">
          <span>{{ $t("exchange_form") }} :</span>
          <v-divider class="ml-2" />
        </div>
        <v-flex xs12 :md6="!edit" class="pt-4">
          <v-layout row wrap class="px-3">
            <v-date
              type="date"
              @change="getRates"
              label="date"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="value.date"
              class="flex xs12 sm6"
              value-type="YYYY-MM-DD"
              input_id="exchange_date"
              :placeholder="$t('date')"
              @input="dateChanged"
              :disabled="edit || disableBackDate"
            />
            <v-date
              type="time"
              label="time"
              format="HH:mm:ss"
              :clearable="false"
              v-model="value.time"
              value-type="HH:mm:ss"
              class="flex xs12 sm6"
              input_id="exchange_time"
              :placeholder="$t('time')"
              :disabled="edit || disableBackDate"
            />
            <async-autocomplete
              outline
              autofocus
              placeholder=" "
              item-value="id"
              class="flex xs12"
              @setItem="setCustomer"
              item-text="full_name"
              :label="$t('customer')"
              v-validate="'required'"
              url="/exchanges/create"
              :edit-append="editAppend"
              :data-vv-name="'customer'"
              v-model="value.customer_id"
              :data-vv-as="$t('customer')"
              :append-item="appendCustomer"
              :error-messages="errors.collect('customer')"
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t(data.item.type)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </async-autocomplete>
            <v-text-field
              outline
              v-model="value.name"
              class="flex xs12 sm6"
              v-validate="'required'"
              :label="$t('full_name')"
              @input="setDescription(0)"
              :data-vv-name="'full_name'"
              :data-vv-as="$t('full_name')"
              placeholder="Customer/Coprporate Name"
              :error-messages="errors.collect('full_name')"
            />
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('father_name')"
              v-model="value.father_name"
            />
            <v-combobox
              outline
              multiple
              small-chips
              placeholder=" "
              :label="$t('phones')"
              class="flex xs12 sm6"
              v-model="value.phones"
            />
            <v-textarea
              outline
              rows="1"
              auto-grow
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('address')"
              v-model="value.address"
            />
            <v-checkbox
              singleLine
              hideDetails
              color="primary"
              v-model="showExtra"
              class="flex xs12 sm6"
              :label="$t('full_details')"
            />
            <template v-if="showExtra">
              <v-radio-group row v-model="value.doctype" class="flex xs12 sm6 mb-4">
                <v-radio label="Passport" value="passport"></v-radio>
                <v-radio label="Tazkira" value="tazkira"></v-radio>
                <v-radio label="License No" value="license"></v-radio>
              </v-radio-group>
              <v-text-field
                outline
                :label="$t('docno')"
                v-model="value.docno"
                class="flex xs12 sm6"
                placeholder="Passport/Tazkira/License"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                key="nature_of_business"
                :label="$t('nature_of_business')"
                v-if="value.doctype == 'license'"
                v-model="value.nature_of_business"
              />
              <v-text-field
                outline
                key="nationality"
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('nationality')"
                v-model="value.nationality"
                v-if="value.doctype != 'license'"
              />
              <v-text-field
                outline
                placeholder=" "
                key="place_of_birth"
                class="flex xs12 sm6"
                :label="$t('place_of_birth')"
                v-model="value.place_of_birth"
              />
              <v-date
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                input_id="date_of_birth"
                class="flex xs12 sm6 pt-0"
                :placeholder="$t('date_of_birth')"
                v-model="value.date_of_birth"
                v-if="value.doctype != 'license'"
              />
              <v-text-field
                outline
                placeholder=" "
                key="occupation"
                class="flex xs12 sm6"
                :label="$t('occupation')"
                v-model="value.occupation"
              />
              <!-- v-if="value.doctype != 'license'" -->
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                browser-autocomplete="on"
                :label="$t('source_of_fund')"
                v-model="value.source_of_fund"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                browser-autocomplete="on"
                :label="$t('purpose_of_transaction')"
                v-model="value.purpose_of_transaction"
              />
            </template>
          </v-layout>
          <v-layout row wrap class="px-3">
            <template v-for="(item, index) in value.items">
              <div class="di-flex align-center mb-4 flex xs12" :key="`${index}0`">
                <v-btn icon flat small color="primary" @click="addItem" v-if="index == 0">
                  <v-icon>add_circle</v-icon>
                </v-btn>
                <v-btn icon flat small color="pink" v-if="index > 0" @click="removeItem(index)">
                  <v-icon>close</v-icon>
                </v-btn>
                <strong class="body-2 mt-1">{{ `${$t("transaction_details")} ${index + 1}` }}</strong>
                <v-divider class="mx-2"></v-divider>
              </div>
              <v-autocomplete
                outline
                placeholder=" "
                item-value="id"
                item-text="name"
                persistent-hint
                :key="`${index}_2`"
                :items="buyAccounts"
                v-validate="'required'"
                :label="$t('buy_account')"
                :data-vv-as="$t('buy_account')"
                v-model="item.buy_customer_id"
                @change="setDescription(index)"
                class="flex xs12 sm6 right-hint"
                :data-vv-name="'buy_account' + index"
                :error-messages="errors.collect('buy_account' + index)"
              />
              <!-- :hint="
                  cItems[index].buyAccountBalance
                    | currency({ symbol: smbl(item.buy_currency_id) })
              "-->
              <v-autocomplete
                outline
                placeholder=" "
                item-value="id"
                item-text="name"
                persistent-hint
                :key="`${index}_1`"
                :items="saleAccounts"
                v-validate="'required'"
                :label="$t('sale_account')"
                @change="setDescription(index)"
                class="flex xs12 sm6 right-hint"
                v-model="item.sale_customer_id"
                :data-vv-as="$t('sale_account')"
                :data-vv-name="'sale_account' + index"
                :error-messages="errors.collect('sale_account' + index)"
              />
              <!-- :hint="
                  cItems[index].saleAccountBalance
              | currency({ symbol: smbl(item.sale_currency_id) })-->
              <v-autocomplete
                outline
                placeholder=" "
                item-value="id"
                item-text="name"
                :key="`${index}_4`"
                :items="currencies"
                class="flex xs12 sm6"
                v-validate="'required'"
                :label="$t('buy_currency')"
                v-model="item.buy_currency_id"
                @change="setRates(index, true)"
                :data-vv-as="$t('buy_currency')"
                :data-vv-name="'buy_currency' + index"
                :error-messages="errors.collect('buy_currency' + index)"
              />
              <v-autocomplete
                outline
                placeholder=" "
                item-value="id"
                item-text="name"
                :key="`${index}_3`"
                :items="currencies"
                class="flex xs12 sm6"
                v-validate="'required'"
                :label="$t('sale_currency')"
                @change="setRates(index, true)"
                v-model="item.sale_currency_id"
                :data-vv-as="$t('sale_currency')"
                :data-vv-name="'sale_currency' + index"
                :error-messages="errors.collect('sale_currency' + index)"
              />
              <v-text-field
                outline
                persistentHint
                type="number"
                placeholder=" "
                :label="$t('rate')"
                :key="`${index}_9`"
                v-model="item.rate"
                :data-vv-name="'rate'"
                v-validate="'required'"
                :data-vv-as="$t('rate')"
                class="flex xs12 right-hint"
                @input="setRates(index, false)"
                :hint="` ${value.items[index].avr_rate}`"
                :error-messages="errors.collect('rate')"
              />
              <!-- <v-text-field
                outline
                type="number"
                placeholder=" "
                :key="`${index}_6`"
                class="flex xs12 sm6"
                v-validate="'required'"
                :label="$t('buy_to_base_rate')"
                v-model="item.buy_to_base_rate"
                :data-vv-as="$t('buy_to_base_rate')"
                :disabled=" cItems[index].isSale"
                :data-vv-name="'buy_to_base_rate' + index"
                @input="amountChanged(false, false, index)"
                :error-messages="errors.collect('buy_to_base_rate' + index)"
              />
              <v-text-field
                outline
                type="number"
                placeholder=" "
                :key="`${index}_5`"
                class="flex xs12 sm6"
                v-validate="'required'"
                :label="$t('sale_to_base_rate')"
                v-model="item.sale_to_base_rate"
                :data-vv-as="$t('sale_to_base_rate')"
                :disabled="cItems[index].isBuy"
                @input="amountChanged(false, false, index)"
                :data-vv-name="'sale_to_base_rate' + index"
                :error-messages="errors.collect('sale_to_base_rate' + index)"
              />-->
              <v-text-field
                outline
                persistentHint
                placeholder=" "
                :key="`${index}_8`"
                :label="$t('amount')"
                v-validate="'required'"
                :data-vv-as="$t('amount')"
                v-currency="{ currency: null }"
                v-model="item.exchanged_amount"
                @keyup="exchangeAmountEntered(index)"
                class="flex xs12 sm6 mb-2 capitalize"
                :hint="item.exchanged_amount | toWord"
                :data-vv-name="'exchanged_amount' + index"
                :error-messages="errors.collect('exchanged_amount' + index)"
              />
              <v-text-field
                outline
                persistentHint
                placeholder=" "
                :key="`${index}_7`"
                :label="$t('amount')"
                v-model="item.amount"
                v-validate="'required'"
                :data-vv-as="$t('amount')"
                :hint="item.amount | toWord"
                @keyup="amountChanged(index)"
                v-currency="{ currency: null }"
                class="flex xs12 sm6 mb-2 capitalize"
                :data-vv-name="'amount' + index"
                :error-messages="errors.collect('amount' + index)"
              />
              <v-autocomplete
                outline
                placeholder=" "
                :key="index + 'k2'"
                class="flex xs12 sm6 capitalize"
                v-validate="'required'"
                :label="$t('risk_profile')"
                v-model="item.risk_category"
                :items="['Low', 'Medium', 'High']"
                :data-vv-name="'risk_profile'"
                :data-vv-as="$t('risk_profile')"
                :error-messages="errors.collect('risk_profile')"
              />
              <v-textarea
                outline
                rows="0"
                auto-grow
                :key="`${index}_11`"
                placeholder="Details"
                v-model="item.description"
                :label="$t('description')"
                @keyup.enter.shift="addItem"
                class="flex xs12 sm6 mb-2 capitalize"
              />
              <v-checkbox
                :key="index + 'k'"
                placeholder
                singleLine
                hide-details
                color="primary"
                :label="$t('is_dab')"
                v-model="item.is_dab"
                class="flex xs12 sm6"
                style="max-width: 320px"
              />
            </template>

            <v-checkbox
              single-line
              hide-details
              color="primary"
              class="flex xs12 sm6 md4"
              :label="$t('suction_checked')"
              v-model="value.suction_checked"
            />
            <v-checkbox
              single-line
              hide-details
              color="primary"
              :label="$t('pep')"
              v-model="value.pep"
              class="flex xs12 sm6 md4"
            />

            <v-flex xs12 class="flex-row align-center pt-0" v-if="showCredit">
              <v-checkbox
                placeholder
                singleLine
                hide-details
                color="primary"
                class="mb-4 pa-0"
                style="max-width: 32px"
                v-model="value.has_credit"
              />
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                persistentHint
                class="flex xs12 right-hint"
                :disabled="!value.has_credit"
                :label="$t('credit_description')"
                data-vv-name="credit_description"
                v-model="value.credit_description"
                :data-vv-as="$t('credit_description')"
                v-validate="value.has_credit ? 'required' : ''"
                :error-messages="errors.collect('credit_description')"
                :hint="
                  total_summery | currency({ symbol: smbl(base_currency_id) })
                "
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 mt-2>
              <v-btn dark raised @click="save" color="primary" :loading="loading">{{ $t("save") }}</v-btn>
              <v-btn
                dark
                outline
                class="mx-0"
                color="primary"
                :loading="loading"
                @click="save(false)"
                :title="$t('save_print')"
              >
                <v-icon class="mx-2">print</v-icon>
              </v-btn>
              <v-btn
                dark
                raised
                outline
                v-if="!edit"
                @click="reset"
                color="primary"
                :loading="loading"
                :title="$t('new_record')"
              >
                <v-icon class="mx-1">mdi-refresh</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 :md4="!edit" class="mt-3 hidden-sm-and-down">
          <v-layout row wrap class="justify-center mb-3">
            <v-flex xs12 class="di-flex align-center justify-space-between">
              <div class="caption">
                <strong>{{ $t("files") }}</strong>
                <br />
                {{ $t("file_max_notation") }}
              </div>
              <file-chooser text color="secondary" v-model="value.files" />
            </v-flex>
            <v-flex xs12 v-if="value.files && value.files.length > 0" class="mt-3">
              <file-viewer :files="value.files" />
            </v-flex>
          </v-layout>
          <customer-tile :customer="customer" v-if="!edit" />
        </v-flex>
        <v-flex xs12 md6 v-show="false" class="px-4 hidden-xs-only">
          <exchange-bill
            ref="bill"
            :key="value.name"
            v-bind="{ exchange: value, customer, system }"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { customersMixin, printBill, exchange } from "@/mixins/index.js";
import curjs from "currency.js";

export default {
  name: "ExchangeForm",
  mixins: [customersMixin, printBill, exchange],
  props: {
    classProp: { default: "" },
    edit: { type: Boolean, default: false },
    value: {
      default: () => ({
        id: null,
        files: [],
        details: {},
        amount: null,
        description: "",
        customer_id: null,
        buy_currency_id: null,
        sale_currency_id: null,
        exchanged_amount: null,
        date: new Date().toLocaleDateString("en-ca")
      })
    }
  },

  data() {
    return {
      saved: false,
      currencies: [],
      loading: false,
      showExtra: false,
      // buyer: {
      //   id: this.value.buy_customer_id,
      //   accounts: [],
      // },
      customer: {
        type: "new_customer",
        accounts: [],
        details: {}
      }
    };
  },

  computed: {
    editAppend() {
      if (this.value.id) return this.value.customer;
      return false;
    },
    appendCustomer() {
      return {
        details: [],
        id: this.system.id,
        type: "new_customer",
        full_name: this.$t("new_customer"),
        image: require("@/assets/images/userplaceholder.svg"),
        reg_id: "Ex_" + (this.system.last_customer_reg_number + 1)
      };
    },
    showCredit() {
      return (
        this.has_credit &&
        this.value.items.length > 1 &&
        this.customer.type != "external" &&
        this.customer.type != "new_customer"
      );
    },

    total_summery() {
      let amount = curjs(0);
      this.value.items.forEach(item => {
        if (item.sale_currency_id == this.base_currency_id) {
          amount = amount.add(curjs(item.amount));
        }
      });
      this.value.credit_amount = amount.value;
      return amount.value;
    },

    // currencies: (vm) => vm.initialData.currencies,
    system() {
      let system = this.initialData.customers.find(x => x.type == "system");
      return system
        ? system
        : {
            accounts: []
          };
    },

    base_currency() {
      let currency = this.currencies.find(x => x.id === this.base_currency_id);
      return currency ? currency : { rank: 1, name: "", rate: 1 };
    },

    // customer: (vm) =>
    //   vm.customers.find((x) => x.id == vm.value.customer_id) || {
    //     accounts: [],
    //     type: "external",
    //   },

    isNewCustomer: vm => vm.customer.type == "new_customer",

    saleAccounts() {
      let accounts = this.initialData.customers.filter(
        x => x.is_bank && x.type != "DailyProfit" && x.type != "stock"
      );
      if (
        this.customer.type != "new_customer" &&
        this.customer.type != "external" &&
        this.customer.type != "system"
      )
        return [
          {
            id: this.value.customer_id,
            name: "Customer Account",
            accounts: this.customer.accounts
          },
          ...accounts
        ];
      return accounts;
    },

    buyAccounts() {
      // if customer account is selected
      // if (
      //   this.value.sale_customer_id == this.customer.id &&
      //   !this.isNewCustomer
      // )
      //   return [
      //     {
      //       id: this.customer.id,
      //       name: "Customer Account",
      //       accounts: this.customer.accounts,
      //     },
      //   ];

      return this.saleAccounts;
    },

    cItems() {
      let data = [];
      this.value.items.forEach(item => {
        let bcurrency = this.currencies.find(
          x => x.id === item.buy_currency_id
        ) || { rank: 1, rate: 1 };
        let scurrency = this.currencies.find(
          x => x.id === item.sale_currency_id
        ) || { rank: 1, rate: 1 };
        let saler = this.saleAccounts.find(
          x => x.id == item.sale_customer_id
        ) || { id: item.sale_customer_id, accounts: [] };

        saler.accounts = [];
        let buyer = this.buyAccounts.find(
          x => x.id == item.buy_customer_id
        ) || {
          id: item.buy_customer_id,
          accounts: []
        };

        let saleAccount = saler.accounts.find(
          x => x.currency_id == item.sale_currency_id
        ) || { balance: 0 };

        let buyAccount = buyer.accounts.find(
          x => x.currency_id == item.buy_currency_id
        ) || { balance: 0 };

        let d = {
          saler,
          buyer,
          buyAccountBalance: buyAccount.balance,
          buy_to_base_rate: item.buy_to_base_rate,
          saleAccountBalance: saleAccount.balance,
          sale_to_base_rate: item.sale_to_base_rate,
          accounts_name: `${saler.name} - ${buyer.name}`,
          isBuy: item.sale_currency_id == this.base_currency_id,
          isSale: item.buy_currency_id == this.base_currency_id,
          buyCurrency: bcurrency ? bcurrency : { rank: 1, name: "", rate: 1 },
          saleCurrency: scurrency ? scurrency : { rank: 1, name: "", rate: 1 }
        };
        data.push(d);
      });
      return data;
    }
  },

  methods: {
    addItem() {
      this.value.items.push({
        rate: 1,
        amount: null,
        base_amount: null,
        buy_currency_id: null,
        buy_to_base_rate: null,
        exchanged_amount: null,
        sale_currency_id: null,
        sale_to_base_rate: null,
        buy_customer_id: this.system.id,
        sale_customer_id: this.system.id
      });
    },
    removeItem(index) {
      this.value.items.splice(index, 1);
    },

    reset() {
      this.saved = false;
      this.$emit("reset");
      this.loading = false;
      this.$validator.reset();
      // this.customer = {
      //   type: "external",
      //   accounts: [],
      //   details: {},
      // };
    },

    setCustomer(customer) {
      this.customer = customer;
      this.customerChanged();
    },

    customerChanged() {
      if (this.customer.type == "individual") {
        this.value.name = this.customer.name;
        this.value.corporate_name =
          this.customer.individual.business_name || this.customer.name;
        this.value.reg_id = this.value.customer_id;
        this.value.phones = this.customer.individual.phones;
        this.value.father_name = this.customer.individual.father_name;
        this.value.address = this.customer.individual.current_address;
        this.value.occupation = this.customer.individual.occupation;
        this.value.source_of_fund = this.customer.individual.source_of_fund;
        this.value.purpose_of_transaction = "Business";
        this.value.nationality = this.customer.individual.nationality;
        this.value.place_of_birth = this.customer.individual.place_of_birth;
        this.value.date_of_birth = this.customer.individual.date_of_birth;
        this.value.issue_date = this.customer.individual.issue_date;
        this.value.expire_date = this.customer.individual.expire_date;

        let doctype = this.customer.individual.doctype;
        if (doctype == "passport")
          this.value.docno = this.customer.individual.passport_no;

        if (doctype == "tazkira")
          this.value.docno = this.customer.individual.tazkira_no;
        this.value.doctype = doctype;
      } else if (this.customer.type == "corporate") {
        this.value.doctype = "license";
        this.value.corporate_name = this.customer.name;
        this.value.reg_id = this.value.customer_id;
        this.value.docno = this.customer.corporate.license_no;
        this.value.address = this.customer.corporate.business_address;
        this.value.phones = this.customer.corporate.company_phones;
        this.value.address = this.customer.corporate.business_address;
        this.value.issue_date = this.customer.corporate.license_issue_date;
        this.value.expire_date = this.customer.corporate.license_expire_date;
        this.value.nature_of_business = this.customer.corporate.nature_of_business;
        this.value.name = this.customer.director.name;
        this.value.father_name = this.customer.director.father_name;
        this.value.occupation = this.customer.corporate.occupation;
        this.value.source_of_fund = this.customer.corporate.source_of_fund;
        this.value.purpose_of_transaction = "Business";
        this.value.nationality = this.customer.director.nationality;
        this.value.place_of_birth = this.customer.director.place_of_birth;
        this.value.date_of_birth = this.customer.director.date_of_birth;
        this.value.issue_date = this.customer.director.issue_date;
        this.value.expire_date = this.customer.director.expire_date;
      } else if (this.customer.type == "external") {
        if (this.customer.exchange_detail.id) {
          this.$emit("input", {
            ...this.customer.exchange_detail,
            id: undefined,
            time: this.value.time,
            date: this.value.date,
            exchange_id: undefined,
            items: this.value.items,
            customer_id: this.customer.id
          });
        } else if (this.customer.transfer_detail.id) {
          this.$emit("input", {
            ...this.customer.transfer_detail,
            id: undefined,
            date: this.value.date,
            time: this.value.time,
            transfer_id: undefined,
            items: this.value.items,
            customer_id: this.customer.id
          });
          // this.value = Object.assign(
          //   {},

          // );
          delete this.value.id;
          delete this.value.transfer_id;
        }
      } else if (this.customer.type == "new_customer") {
        this.$emit("input", {
          doctype: "passport",
          time: this.value.time,
          date: this.value.date,
          items: this.value.items,
          name: this.customer.name,
          customer_id: this.customer.id,
          reg_id: this.value.customer_id,
          corporate_name: this.customer.name,
          father_name: this.customer.father_name,
          files: []
        });
      } else {
        this.value.name = this.customer.name;
        this.value.father_name = this.customer.father_name;
        this.value.corporate_name = this.customer.name;
        this.value.reg_id = this.customer.id;
      }
      this.setDescription(0);
    },

    setRates(index, setRate = false) {
      let saleCurrency = this.cItems[index].saleCurrency;
      let buyCurrency = this.cItems[index].buyCurrency;

      this.value.items[index].buy_to_base_rate = this.cItems[
        index
      ].buyCurrency.rate;
      this.value.items[index].sale_to_base_rate = this.cItems[
        index
      ].saleCurrency.rate;
      // if()

      if (setRate) {
        this.value.items[index].avr_rate = this.value.items[
          index
        ].rate = this.getRate(
          saleCurrency.rank,
          buyCurrency.rank,
          this.base_currency.rank,
          this.value.items[index].sale_to_base_rate,
          this.value.items[index].buy_to_base_rate
        );
      } else {
        if (saleCurrency.rank == this.base_currency.rank)
          this.value.items[index].buy_to_base_rate = this.value.items[
            index
          ].rate;
        else if (buyCurrency.rank == this.base_currency.rank)
          this.value.items[index].sale_to_base_rate = this.value.items[
            index
          ].rate;
        else
          this.value.items[index].sale_to_base_rate = this.getSaleRate(
            saleCurrency.rank,
            buyCurrency.rank,
            this.base_currency.rank,
            this.value.items[index].rate,
            this.value.items[index].buy_to_base_rate
          );
      }
      this.exchangeAmountEntered(index);
    },

    amountChanged(index) {
      let saleCurrency = this.cItems[index].saleCurrency;
      let buyCurrency = this.cItems[index].buyCurrency;

      this.value.items[index].base_amount = curjs(
        this.exchange(
          saleCurrency,
          this.base_currency,
          curjs(this.value.items[index].amount).value,
          this.value.items[index].sale_to_base_rate
        )
      ).value;

      // : null,
      this.value.items[index].exchanged_amount = curjs(
        this.exchange(
          saleCurrency,
          buyCurrency,
          curjs(this.value.items[index].amount).value,
          this.value.items[index].rate
        )
      ).format({ symbol: "" });
      this.setDescription(index);
    },

    setDescription(index) {
      this.value.items[index].description = `${this.$t("buy")} ${this.smbl(
        this.cItems[index].buyCurrency.id,
        this.isRTL
      )} - ${this.$t("sale")} ${this.smbl(
        this.cItems[index].saleCurrency.id,
        this.isRTL
      )} ${this.$t("rate_of")} ${this.value.items[index].rate} ${this.$t(
        "with"
      )} ${this.value.corporate_name || this.value.name} (${
        this.cItems[index].buyer.name
      } ${this.cItems[index].buyCurrency.name} - ${
        this.cItems[index].saler.name
      } ${this.cItems[index].saleCurrency.name}) `;
    },

    exchangeAmountEntered(index) {
      let saleCurrency = this.cItems[index].saleCurrency;
      let buyCurrency = this.cItems[index].buyCurrency;

      this.value.items[index].base_amount = curjs(
        this.exchange(
          buyCurrency,
          this.base_currency,
          curjs(this.value.items[index].exchanged_amount).value,
          this.value.items[index].buy_to_base_rate
        )
      ).value;

      this.value.items[index].amount = curjs(
        this.exchange(
          buyCurrency,
          saleCurrency,
          curjs(this.value.items[index].exchanged_amount).value,
          this.value.items[index].rate
        )
      ).format({ symbol: "" });
      this.setDescription(index);
    },

    async save(disablePrint = true) {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.value.number =
            this.value.number ||
            (this.system && this.system.last_form_number++);
          if (this.isNewCustomer) {
            this.value.reg_id =
              this.value.reg_id ||
              (this.system && this.system.last_customer_reg_number++);
          }
          this.value.isNewCustomer = this.isNewCustomer;
          this.value.edit = this.edit || this.saved;
          // this.value.accounts_name = `${this.saler.name} - ${this.buyer.name}`;
          this.axios
            .post("exchanges", this.value)
            .then(async res => {
              this.value.id = res.data.id;
              if (this.value.files) {
                let fils = this.value.files.filter(x => !x.id);
                if (fils.length > 0) {
                  const fd = new FormData();
                  fd.append("fileable_type", "ExchangeDetail");
                  fd.append("fileable_id", res.data.id);
                  for (const file of fils) {
                    fd.append("files[]", file);
                  }
                  await this.axios.post("files", fd, {
                    headers: {
                      "Content-Type": "multipart/form-data"
                    }
                  });
                }
              }
              // this.value.date = res.data.date;
              await this.getCustomers();
              this.getRates();
              this.printBill(this.$refs.bill.$el, disablePrint);
              this.loading = false;
              this.saved = true;
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true
              });
              this.$emit("saved", res.data);
              this.reset();
            })
            .catch(error => {
              console.error(error);
              this.$store.commit("showSnackbar", {
                text: error.response.data.message,
                stateType: "error",
                show: true
              });
              this.loading = false;
            });
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
          this.loading = false;
        }
      });
    },

    dateChanged() {
      this.$emit("date-changed");
      this.getRates();
    },

    getRates() {
      this.axios
        .get(
          `reports?ratesByDate=true&date=${this.value.date}&branch_id=${this
            .branch_id || this.user.branch_id}`
        )
        .then(res => {
          this.currencies = Object.values(res.data);
        });
    }
  },
  created() {
    if (this.value.id) this.customer = this.value.customer;
    this.getRates();
  }
};
</script>
